import { render, staticRenderFns } from "./file-preivew-item.vue?vue&type=template&id=2111e38d&scoped=true&"
import script from "./file-preivew-item.vue?vue&type=script&lang=js&"
export * from "./file-preivew-item.vue?vue&type=script&lang=js&"
import style0 from "./file-preivew-item.vue?vue&type=style&index=0&id=2111e38d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2111e38d",
  null
  
)

export default component.exports